module.exports = __webpack_public_path__ + "static/material-glossy.3a168776.svg";